import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import * as amountTrans from '../../translations/amount/amount_translations';


class SizeItem extends Component {
  handleChange = (amount) => {
    this.props.updateSizeSelection(
      amount,
      parseInt(this.props.sizeId, 10),
      this.props.productID,
      this.props.choiceID,
      this.props.inStock,
      this.props.subgroupID,
      );
  }

  render() {
    const amount = this.props.sizeSelection.filter(
      size => size.subgroupID === this.props.subgroupID
      && size.productID === this.props.productID &&
      size.sizeID === this.props.sizeId,
      ).map(el => el.amount || '');

    const isValid = amount <= this.props.inStock && amount >= 0;

    return (
      <div className="sizeItemContainer">
        <div className="sizeItemContent">
          <div className="sizeName">{this.props.name}</div>
          <input
            type="number"
            id={`input${this.props.sizeId}`}
            className={`amount ${this.props.amount !== '' ? 'hasValue' : ''}${isValid ? '' : ' notvalid'}`}
            value={amount}
            onChange={e => this.handleChange(e.target.value)}
            pattern="[0-9]*"
            placeholder="0"
            min="0"
            max={this.props.inStock}
          />
          <span className="stockInfo">
            {this.props.inStock}
            {' '}
            {this.props.settings.locale === 'de-AT' ? amountTrans.at.in_stock : amountTrans[this.props.settings.locale].in_stock}
          </span>
        </div>
      </div>
    );
  }
}

const mapDispatch = dispatch => (
  {
    updateSizeSelection: (amount, sizeID, productID, choicesID, inStock, subgroupID) => dispatch({
      type: 'UPDATES_SIZE_SELECTION',
      amount,
      sizeID,
      productID,
      choicesID,
      inStock,
      subgroupID,
    }),
  }
);

const mapState = state => (
  {
    sizeSelection: state.sizeSelection,
    settings: state.settings,
  }
);

export default withRouter(connect(mapState, mapDispatch)(SizeItem));
